import type { SearchRadioStation } from '@/mocks/searchRadios';
import RadioResultCard from './RadioResultCard';

interface SearchResultsProps {
  results: SearchRadioStation[];
  query: string;
  hasFilters: boolean;
  onClearAll: () => void;
}

export default function SearchResults({ results, query, hasFilters, onClearAll }: SearchResultsProps) {
  if (results.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <div className="w-20 h-20 flex items-center justify-center rounded-full bg-background-100 mb-4">
          <i className="ri-search-eye-line text-3xl text-foreground-300"></i>
        </div>
        <h3 className="text-lg font-semibold text-foreground-800 mb-1">Sin resultados</h3>
        <p className="text-sm text-foreground-500 max-w-sm">
          {query && hasFilters
            ? 'No encontramos radios que coincidan con tu búsqueda y filtros activos.'
            : query
            ? 'Prueba con otro nombre, frecuencia, ciudad o palabra clave.'
            : 'No hay radios que coincidan con los filtros seleccionados.'}
        </p>
        {hasFilters && (
          <button
            onClick={onClearAll}
            className="mt-4 px-4 py-2 text-sm font-medium text-primary-600 hover:text-primary-700 bg-primary-50 hover:bg-primary-100 rounded-lg transition-all cursor-pointer"
          >
            <i className="ri-close-circle-line mr-1.5"></i>
            Limpiar filtros
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
      {results.map((radio) => (
        <RadioResultCard key={radio.id} radio={radio} query={query} />
      ))}
    </div>
  );
}